import { Injectable } from '@angular/core';
import { Headers, Http, RequestMethod, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CommonConstant } from '../../shared/constants/common.constants';

@Injectable()
export class BatchProcessingService {
    constructor(private _http: Http) { }

    /**
     * To Initiate the file uploads from s3 bucket
     * @param fileUploadInfo
     * @returns
     */
    initiateFileUploadJob(fileUploadInfo): Observable<any> {
        const fileUploadURL =
            ApiUrlConstants.batchApiUrl + 'file-upload';
        return this._http.post(fileUploadURL, fileUploadInfo)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * To Upload the files into s3 bucket
     * @param formData
     * @returns
     */
    uploadFile(formData): Observable<any> {
        let url = ApiUrlConstants.batchApiUrl + '/upload-file';
        if(environment && environment.enableFileUploadToPrivate) {
          url = url + '?isPrivate=true';
        }
        const headers = new Headers();
        headers.append('Content-Type', 'multipart/form-data');
        const options = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        return this._http
            .post(url, formData, options)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * To Get activity logs
     */
    getActivityLog(): Observable<any> {
        const activityLogURL =
            ApiUrlConstants.batchApiUrl + 'file-upload-logs?maxResults=10&categoryName=' + CommonConstant.RECOGNITION;

        return this._http.get(activityLogURL)
            .map((res) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response | any) {
      return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/batch-processing.service.ts